import { render, staticRenderFns } from "./ActionSheep.vue?vue&type=template&id=a5fdde0c&scoped=true"
import script from "./ActionSheep.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionSheep.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActionSheep.vue?vue&type=style&index=0&id=a5fdde0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fdde0c",
  null
  
)

export default component.exports